import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  tabPanelContainer: {
    [theme.breakpoints.down('md')]: {
      margin: '20px',
    },
  },
}));

export default useStyles;
